export const handleScrollToTop = () => {
  window.scrollTo(0, 0);
};
